import { render } from "./aging-report.vue?vue&type=template&id=52078a3a"
import script from "./aging-report.vue?vue&type=script&lang=js"
export * from "./aging-report.vue?vue&type=script&lang=js"

import "./aging-report.vue?vue&type=style&index=0&id=52078a3a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__